<template>
  <el-select
    v-model="valueBackup"
    placeholder="请输入标签名称进行搜索"
    multiple
    filterable
    remote
    :remote-method="handleRemote"
    :loading="isLoading"
    @change="handleChange"
  >
    <v-avatar-option
      :value="listBackup"
      :ratio="1.78"
      radius="5px"
      avatar-key="cover"
      name-key="course_tag_name"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/course-tag';

export default {
  props: {
    value: [Array, String],
    list: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    valueBackup: '',
    listBackup: [],
    isLoading: false,
  }),
  watch: {
    value(value) {
      if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
    },
    valueBackup(valueBackup) {
      if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
    },
    list(list) {
      if (JSON.stringify(list) !== JSON.stringify(this.listBackup)) this.listBackup = list || [];
    },
  },
  methods: {
    handleChange(valueBackup) {
      if (!valueBackup.length) return;

      for (let i = 0; i  < this.listBackup.length; i++) {
        if (this.listBackup[i].id === valueBackup[0]) return this.$emit('itemChange', this.listBackup[i]);
      }
    },
    async getList(keyword) {
      this.isLoading = true;
      const { isError, data } = await index({ keyword, is_disable_count: 1 });
      this.isLoading = false;
      if (!isError) this.listBackup = data;
    },
    handleRemote(keyword) {
      if (keyword) return this.getList(keyword);

      this.list = [];
    },
  },
  beforeMount() {
    this.valueBackup = this.value || [];
    if (this.list.length) {
      return this.listBackup = this.list;
    }

    this.getList('');
  },
};
</script>
